import { Box, Typography } from '@mui/material'

export const ThanksPage = () => {
  return (
    <Box display={'flex'} justifyContent={'center'} paddingTop={3}>
      <Box display={'grid'}>
        <Typography>この度はお問い合わせいただき、誠にありがとうございました。</Typography>
      </Box>
    </Box>
  )
}
